import { mdiCheckCircleOutline, mdiDownloadOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { RequerimentoService } from '../../common/services/requerimento';

export const SuccessCard = ({ data, protocolo, status, nomeRequerimento }) => {
  const custom = useSelector((state) => state.customizaSistema);
  const { matricula, token } = useSelector((state) => state.user);
  const [loadingPDF, setLoadingPDF] = useState(false);

  function baixarArquivoPDF(protocoloRequest) {
    try {
      const service = new RequerimentoService();
      setLoadingPDF(true);
      service
        .gerarPDFRequerimento({
          matricula,
          protocolo: protocoloRequest,
          token,
        })
        .then((res) => {
          const blob = new Blob([res], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Requerimento participante - ${matricula}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          setLoadingPDF(false);
        });
    } catch (error) {
      toast.error(`Erro ao gerar o PDF do requerimento`);
    }
  }

  return (
    <>
      <div className="transformacaoSuccess">
        <Icon
          path={mdiCheckCircleOutline}
          color="#FFF"
          alt="File Icon"
          size={2}
        />
        <h2>A solicitação de {nomeRequerimento} foi realizada com sucesso!</h2>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="transformacaoSuccessWrapper">
            <div className="tranformacaoSuccessContent">
              <h2>
                Seu número de protocolo é: <strong>{protocolo}</strong>
              </h2>

              <p className="tbdescription">
                <b>Status: {status}</b>
              </p>

              <p className="tbdescription">
                Sua solicitação de {nomeRequerimento} foi realizada em {data}{' '}
                com sucesso. O processamento está previsto para até 2 dias
                úteis.
              </p>
            </div>

            <div className="transformacaoSuccessLinks">
              <button
                disabled={loadingPDF}
                onClick={() => baixarArquivoPDF(protocolo)}
              >
                <p>
                  <Icon
                    path={mdiDownloadOutline}
                    color={custom.codCorLaranja}
                    alt="File Icon"
                    size={1.25}
                  />
                  Baixar comprovante
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
